export const MARKETING_PROMOTION_NAME_MAX_LENGTH = 50;

export const validateMarketingPromotionName = (name) => {
  const trimmedName = name?.trim?.() || '';

  if (!trimmedName) {
    return 'Tên ưu đãi là bắt buộc';
  }

  if (trimmedName.length > MARKETING_PROMOTION_NAME_MAX_LENGTH) {
    return `Tên ưu đãi tối đa ${MARKETING_PROMOTION_NAME_MAX_LENGTH} ký tự`;
  }

  return '';
};
